import { ActionType } from '../../constants/ActionTypes'
import config from '../../constants/Configs'
import { RestPath } from '../../constants/SitePaths'
import { Constants } from '../../constants/Constants'
import axios from 'axios'

export const getCurrenciesBegin = () => ({
    type: ActionType.GET_CURRENCIES_BEGIN
});

export const getCurrenciesSuccess = (data) => ({
    type: ActionType.GET_CURRENCIES_SUCCESS,
    payload: data
});

export const getCurrenciesError = (data) => ({
    type: ActionType.GET_CURRENCIES_FAILURE,
    payload: data
});

export function getCurrencies() {
    return dispatch => {
        dispatch(getCurrenciesBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CURRENCIES,

        }).then((response) => {
            dispatch(getCurrenciesSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getCurrenciesError(error));
            });
    }
}



// WEBPACK FOOTER //
// ./src/actions/settings/CurrencyActions.js